import React from 'react';
import Icon from 'chameleon/ui-stack/ui/base/icon';

export const PREVIEW_NOW = 'Preview Now';
export const PREVIEW_NOW_DESCRIPTION = `View the questions on the quiz and then decide what to do with it:
Preview Later (add it to quizzes listed under “Shared with Me”), Accept (make a copy for yourself), or Decline (if you are not interested in it).`;

export const PREVIEW_LATER = 'Preview Later';
export const PREVIEW_LATER_DESCRIPTION = `Add the quiz to the “Shared with Me” list of quizzes.
From the list, you can decide whether to Preview the quiz to see its questions, Accept it (make a copy for yourself), or Decline it (remove it from the list)`;

export const MAKE_COPY = 'Accept';

export const MAKE_COPY_DESCRIPTION = (
  <React.Fragment>
    <span>
      This will make <strong>another copy</strong> of the latest version of the
      shared quiz for your use.
    </span>
    <br />
    <span>
      Any teacher-authored questions will be added to the Question Bank and
      marked with a{' '}
      <Icon id="my_copied_question" width={24} height={24} className="mx-1" />{' '}
      to indicate “another educator” created it.
    </span>
  </React.Fragment>
);

export const NAME_COPY = (
  <React.Fragment>
    {' '}
    <strong className="mt-4 text-gray-700">
      Name your copy of the quiz, which you will find under Resources &
      Assignments &#62; All Resources
    </strong>
  </React.Fragment>
);

export const ACCEPT_SHARE_LANDING_MODAL_DESCRIPTION = (
  <React.Fragment>
    <span>
      When you accept a shared quiz,{' '}
      <strong>a copy is made for your use.</strong> The version of the quiz on
      the “Shared with Me” tab will always reflect the sharer's current version
      of the quiz and you can continue to make copies of it.
    </span>
    <span className="mt-5">
      Any teacher-authored questions will be added to the Question Bank and
      marked with a{' '}
      <Icon id="my_copied_question" width={24} height={24} className="mx-1" />{' '}
      to indicate “another educator” created it.
    </span>
    <strong className="mt-5 text-gray-700">
      Name your copy of the quiz, which you will find under Resources &
      Assignments &#62; All Resources
    </strong>
  </React.Fragment>
);

export const DECLINE = 'Decline';
export const DECLINE_DESCRIPTION = `Decline the quiz if you are not interested in it.
It will not appear in your “Shared with Me” list of quizzes. If you change your mind, you will need to go back to the url that was shared with you or the person who shared it.`;

export const UNAUTHORIZED_ACCESS_SHARED_ASSESSMENT =
  'You are not authored to access this shared quiz.  Shared quizzes are only available to educators authorized to see the course in AP Classroom.';
export const UNAUTHORIZED_ADMIN_ACCESS_SHARED_ASSESSMENT = `You cannot access the requested quiz because the course associated with this assessment is not currently being taught in your school(s)`;

export const DEFAULT_DESCRIPTION_TEXT = 'This quiz has no description.';
